import { render } from "./CompanyRulesWidget.vue?vue&type=template&id=3354068d&scoped=true"
import script from "./CompanyRulesWidget.vue?vue&type=script&lang=js"
export * from "./CompanyRulesWidget.vue?vue&type=script&lang=js"

import "./CompanyRulesWidget.vue?vue&type=style&index=0&id=3354068d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3354068d"]])

export default __exports__